import {easeInOutQuad} from 'easings.js';
import scrrroll from 'scrrroll';
import em2px from '@/utils/em2px';

scrrroll.duration = 1000;
scrrroll.easing = easeInOutQuad;

export default function (dom, opts) {
	let options = {
	    aLinks : 'a[href^="#"]',
		...opts

	};

	const links = Array.from(dom.querySelectorAll(options.aLinks));
	const targets = [];

	const targetMargin = em2px(2);
    let headerHeight = document.querySelector('.header').clientHeight;
	let height = dom.clientHeight;
	let currentTarget;

	links.forEach(link => {
		const target = document.querySelector(link.getAttribute('href'));

		if (target) {
			targets.push(target);
		}

		link.addEventListener('click', e => {
			e.preventDefault();

			if (target) {

				const top = target.getBoundingClientRect().top;
				const scroll = window.pageYOffset;
				const destination = Math.ceil(top + scroll) - height - headerHeight;
				scrrroll.to(destination);
			}
		});
	});

	const update = () => {
        const current = [...targets].reverse().find(target => window.pageYOffset >= target.offsetTop - height - targetMargin - headerHeight);

        if (current && current !== currentTarget) {
            const currentLink = links.find(link => {
                return link.getAttribute('href') === `#${current.id}`;
            });
            links.forEach(link => link.classList.remove('active'));
            currentLink.classList.add('active');
            currentLink.closest('ul').scrollTo({top: 0, left: currentLink.closest('li').offsetLeft, behavior: 'smooth'})
        }
        else if (!current) {
            links.forEach(link => link.classList.remove('active'));
        }
        currentTarget = current;
    }

	window.addEventListener('scroll', update);
	window.addEventListener('load', update);

	window.addEventListener('resize', e => {
		height = dom.clientHeight;
        headerHeight = document.querySelector('.header').clientHeight;
	});
}
